import { createStyles, makeStyles } from "@mui/styles";
import { Autocomplete, FormControlProps, SxProps, TextField, Theme } from "@mui/material";
import { forwardRef } from "react";
import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import { Token } from "../theme";

interface AutoCompleteProps {
  label: string;
  inlineLabel?: boolean;
  items: AutoCompleteUIDTO[];
  onChange: (value: AutoCompleteUIDTO) => void;
  value: AutoCompleteUIDTO;
  disablePortal?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme> | undefined;
  readonly?: boolean;
  disabled?: boolean;
  className?: string;
  variant?: FormControlProps["variant"];
}

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      fullWidth: {
        width: "1000px",
      },
    }),
  { index: 1 },
);

export const SimpleAutoComplete = forwardRef(
  (
    {
      items,
      label,
      inlineLabel,
      className,
      onChange,
      value,
      disablePortal = true,
      sx,
      readonly = false,
      disabled = false,
      variant,
      size,
    }: AutoCompleteProps,
    ref: any,
  ) => {
    const classes = useStyles();
    return (
      <Autocomplete
        disablePortal={disablePortal}
        openOnFocus
        options={items}
        getOptionLabel={(option) => option.label}
        sx={sx || { minWidth: 300, marginRight: "10px", marginLeft: "10px" }}
        size={size ?? "small"}
        value={value}
        onChange={(event, newValue) => {
          if (newValue) {
            onChange(newValue);
          }
        }}
        renderInput={(params) =>
          inlineLabel ? (
            <TextField
              ref={ref}
              className={classes.fullWidth}
              {...params}
              variant={variant ?? "outlined"}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <span style={{ color: Token.textTertiary, fontSize: 12, whiteSpace: "nowrap", marginRight: 6 }}>{label}:</span>
                ),
              }}
              inputProps={{
                ...params.inputProps,
                style: { color: Token.textPrimary, fontWeight: 600 },
              }}
            />
          ) : (
            <TextField ref={ref} className={classes.fullWidth} {...params} label={label} variant={variant ?? "outlined"} />
          )
        }
        disableClearable
        readOnly={readonly}
        disabled={disabled}
        className={className}
      />
    );
  },
);
